var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect, useState } from 'react';
import { LIVE_REGION_READY_DELAY } from './LiveRegion.constants';
// Screen readers only announce changes to a region already in the accessibility tree
export const useIsLiveRegionReady = () => {
    _react_refresh_temp_1();
    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        const readyTimer = setTimeout(() => {
            setIsReady(true);
        }, LIVE_REGION_READY_DELAY);
        return () => {
            clearTimeout(readyTimer);
        };
    }, []);
    return isReady;
};
_react_refresh_temp_1(useIsLiveRegionReady, "5KP9N2szXKqzhBqfXaLUZqdM1dk=");
